export function toArray(value) {
  if (value === undefined || value === null) {
    return [];
  }

  return Array.isArray(value) ? value : [value];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-field-form/es/utils/typeUtil.js
// module id = 556
// module chunks = 0